import React, { useContext } from 'react';
import type { ISnackbarData } from '@/utils/notification-bridge';

interface ISnackbarContext {
  setCustomSnack: (data: ISnackbarData) => void;
}

export const SnackbarContext = React.createContext<ISnackbarContext | undefined>(undefined);

export const useSnackbarContext = () => {
  const state = useContext(SnackbarContext);
  if (!state) throw new Error('SnackbarContext not found');
  return state;
};
